"use strict";

exports.__esModule = true;
exports.baseRenderer = exports.RENDERER_TYPE = void 0;
var _baseRenderer = require("./baseRenderer");
exports.RENDERER_TYPE = _baseRenderer.RENDERER_TYPE;
exports.baseRenderer = _baseRenderer.baseRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/baseRenderer/index.js
// module id = 269
// module chunks = 0